import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Button } from "../../atoms/button/Button";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { TextArea } from "../../atoms/textArea/TextArea";
import style from "./agentNotes.module.scss";
import { useAgentNotes } from "../../../hooks/useAgentNotes/UseAgentNotes";
import { useCaseStudyUpload } from "../../../hooks/useCaseStudyUpload/UseCaseStudyUpload";
import { UseGetStoreData } from "../../../hooks/getStoreData/UseGetStoreData";
import { buildCaseStudyEntries } from "../../../utils/caseStudy";
import { urls } from "../../../http";

export const AgentNotes = ({ additionalData, showCaseStudy = true }: { additionalData?: any; showCaseStudy?: boolean }) => {
  const { agentNotes, setAgentNotes, storeAgentNotes, oldAgentNotes } =
    useAgentNotes({ additionalData });
  const { getTicketData } = UseGetStoreData();
  const ticketId = getTicketData?._id;
  const { entries: caseStudyEntries } = getTicketData ? buildCaseStudyEntries(getTicketData) : { entries: [] };
  const {
    fileName,
    handleSelectFile,
    handleUpload,
  } = useCaseStudyUpload(ticketId);

  if (!getTicketData) {
    return null;
  }

  const handleOpenCaseStudy = async (fileName: string) => {
    try {
      const url = `${urls.AZURE_URI}/signedUrl/get-dynamic-document?docFolder=case-studies&docName=${fileName}`;
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error(error);
      alert("Something went wrong!");
    }
  };

  return (
    <>
      <BackgroundWrapper className={style.background}>
        <Container className={style.space}>
          <Container>
            <Text text="Agent Notes" className={style.heading} />
          </Container>
          <Container>
            <TextArea
              className={style.input}
              value={agentNotes}
              setValues={setAgentNotes}
              placeHolder="Write here..."
            />
          </Container>
          <Container className={style.btn_wrapper}>
            <Button
              onClick={storeAgentNotes}
              text="Save"
              className={style.button}
            />
          </Container>
          <Container className={style.space_vert}>
            <Text text="Previous Note:" className={style.heading} />
            {oldAgentNotes?.length ? (
              oldAgentNotes?.map((agent: any) => (
                <Text
                  text={`${agent.message},${agent.date}`}
                  className={style.agentNotes}
                />
              ))
            ) : (
              <p className={style.no_data}>No Data Found</p>
            )}
          </Container>
          {showCaseStudy && (
            <Container className={style.space_vert}>
              <Text text="Case Study :" className={style.heading} />
              <Container className={style.case_study_row}>
                <div className={style.case_study_left}>
                  <Text text="Uploaded Case Study :" className={style.agentNotes} />
                  {caseStudyEntries.length > 0 ? (
                    <span className={style.case_study_files}>
                      {caseStudyEntries.map((entry, index) => (
                        <span key={index}>
                          <span
                            onClick={() => handleOpenCaseStudy(entry.label)}
                            className={style.case_study_link}
                            style={{ cursor: "pointer", textDecoration: "underline" }}
                          >
                            {entry.label}
                          </span>

                          {index < caseStudyEntries.length - 1 ? ', ' : ''}
                        </span>
                      ))}
                    </span>
                  ) : (
                    <span className={style.no_data}>Case study not provided.</span>
                  )}
                </div>
                {fileName && (
                  <Text className={style.file_name} text={`Selected: ${fileName}`} />
                )}
                <input
                  type="file"
                  id="caseFileInput"
                  style={{ display: "none" }}
                  accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                  onChange={handleSelectFile}
                />
                <Button
                  text={fileName ? "Submit Case Study" : "Upload Case Study"}
                  className={style.button}
                  onClick={() => fileName ? handleUpload() : document.getElementById("caseFileInput")?.click()}
                />
              </Container>
            </Container>
          )}
        </Container>
      </BackgroundWrapper>
    </>
  );
};
